import { HttpParams } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { BaseCrudService } from "app/shared/_utils/services/base-crud-service";
import { QueryOperator } from "app/shared/_utils/services/query-operator.enum";
import { ResponsePageable } from "app/shared/_utils/services/responsePageable";
import { LazyLoadEvent } from "primeng/api";
import { Observable } from 'rxjs/Observable';
import { catchError, tap } from "rxjs/operators";
import { PettyCashAccount } from "../entities/petty-cash-account";
import { ParamsGeneralPettyCashResult } from "../model/params-general-pettycash-result";

interface ExtraSearchFields {
  startDateRange01?: Date,
  startDateRange02?: Date,
  code01?: string,
  code02?: string
}


@Injectable()
export class PettyCashAccountService extends BaseCrudService<PettyCashAccount> {

  public uri = '/api/pettyCashAccount/';

  constructor(injector: Injector) {
    super(injector);
    // console.log('Instance PettyCashAccountService');
  }

  buildSentence(entity?: PettyCashAccount, event?: LazyLoadEvent, extraSearchFields?: ExtraSearchFields): HttpParams {
    if (entity || extraSearchFields) {
      let query = '';

      query = query.concat(
        extraSearchFields && extraSearchFields.startDateRange01 && extraSearchFields.startDateRange02 ?
          // tslint:disable-next-line:max-line-length
          `accountDate${QueryOperator.Between}${extraSearchFields.startDateRange01.toISOString()}${QueryOperator.Slash}${extraSearchFields.startDateRange02.toISOString()}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.code01 && extraSearchFields.code02 ?
          // tslint:disable-next-line:max-line-length
          `pettyCashSummary.code${QueryOperator.Between}${extraSearchFields.code01}${QueryOperator.Slash}${extraSearchFields.code02}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        entity.code ?
          `code${QueryOperator.Contain}${entity.code}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.pettyCashMaster) {
        if (entity.pettyCashMaster && entity.pettyCashMaster.id) {
          query = query.concat(
            `pettyCashMaster.id${QueryOperator.Equal}${entity.pettyCashMaster.id}${QueryOperator.Split}`
          );
        }

        if (entity.pettyCashMaster.fiscalYear && entity.pettyCashMaster.fiscalYear.id) {
          query = query.concat(
            `pettyCashMaster.fiscalYear.id${QueryOperator.Equal}${entity.pettyCashMaster.fiscalYear.id}${QueryOperator.Split}`
          );
        }

        if (entity.pettyCashMaster.executingUnit && entity.pettyCashMaster.executingUnit.id) {
          query = query.concat(
            `pettyCashMaster.executingUnit.id${QueryOperator.Equal}${entity.pettyCashMaster.executingUnit.id}${QueryOperator.Split}`
          );
        }
      }
      if (entity.identifier && entity.identifier.id) {
        query = query.concat(
          `identifier.id${QueryOperator.Equal}${entity.identifier.id}${QueryOperator.Split}`
        );
      }
      if (entity.vendor && entity.vendor.id) {
        query = query.concat(
          `vendor.id${QueryOperator.Equal}${entity.vendor.id}${QueryOperator.Split}`
        );
      }
      if (entity.employee && entity.employee.id) {
        query = query.concat(
          `employee.id${QueryOperator.Equal}${entity.employee.id}${QueryOperator.Split}`
        );
      }
      if (entity.transactionType && entity.transactionType.id) {
        query = query.concat(
          `transactionType.id${QueryOperator.Equal}${entity.transactionType.id}${QueryOperator.Split}`
        );
      }
      if (entity.pettyCashSummary && entity.pettyCashSummary.id) {
        query = query.concat(
          `pettyCashSummary.id${QueryOperator.Equal}${entity.pettyCashSummary.id}${QueryOperator.Split}`
        );
      }

      if (entity.pettyCashSummary && entity.pettyCashSummary.status) {
        query = query.concat(
          `pettyCashSummary.status.id${QueryOperator.Equal}${entity.pettyCashSummary.status.id}${QueryOperator.Split}`
        );
      }

      if (entity.balance) {
        console.log('dentro del service::::',entity.balance);
        if (entity.balance == 1) {
          query = query.concat(
            `balance${QueryOperator.GreaterThan}0${QueryOperator.Split}`
          );
        } else {
          query = query.concat(
            `balance${QueryOperator.Equal}0${QueryOperator.Split}`
          );
        }
      }

      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }

    // this.httpParams = this.httpParams.set(QueryOperator.SortParam, 'startContractDate');

    return this.httpParams;
  }

  customSearch(entity?: PettyCashAccount, event?: LazyLoadEvent,
    extraSearchFields?: ExtraSearchFields): Observable<ResponsePageable<PettyCashAccount>> {

    const url = `${this.rutaServidor}${this.uri}search`;
    this.spinnerService.showAll();
    const httpParams = this.buildSentence(entity, event, extraSearchFields);
    return this.httpClient.get<ResponsePageable<PettyCashAccount>>(url, { params: httpParams })
      .pipe(
        tap(response => {
          if (response.numberOfElements > 0) {
            response.content.forEach((value) => {
              // debugger;
              this.convertToDate(value);
            })
          }
          //console.log('response search check here');
          //console.log(response);
          this.spinnerService.hideAll();
          return response;
        })
      );
  }

  searchResult( paramsGeneralPettyCashResult : ParamsGeneralPettyCashResult): Observable<any> {
    console.log('searchResult:::::::::::::');
   const url = `${this.rutaServidor}${this.uri}result`;
   console.log('url:::', url);
   return this.httpClient.post<any>(url, paramsGeneralPettyCashResult)
   .pipe(
     tap(response => {
       console.log('response:::::', response);
       return response;
     }
     )
  );
} 

}



// WEBPACK FOOTER //
// ./src/app/core/services/petty-cash-account.service.ts